import { Box, Skeleton } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

/**
 * Skeleton loader for the onboarding page
 * Shows a preview of the layout while the component loads
 * - Desktop: Two-column layout (Wizzy + Legend | Content)
 * - Mobile: Single-column layout (Content only)
 */
export const OnboardingSkeleton = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          padding: isMobile ? "1rem" : "2rem",
          gap: isMobile ? "1.5rem" : "3rem",
          maxWidth: "1200px",
          width: "100%",
        }}
      >
        {/* Left column - Wizzy + Legend (hidden on mobile) */}
        <Box
          style={{
            flex: "0 0 300px",
            display: isMobile ? "none" : "flex",
            flexDirection: "column",
            gap: "2rem",
          }}
        >
          {/* Wizzy avatar */}
          <Skeleton height={260} width={260} radius="xl" />
          {/* Steps legend */}
          <Box
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <Skeleton height={60} radius="md" />
            <Skeleton height={60} radius="md" />
            <Skeleton height={60} radius="md" />
            <Skeleton height={60} radius="md" />
          </Box>
        </Box>

        {/* Right column - Step content */}
        <Box
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: isMobile ? "1rem" : "2rem",
            maxWidth: isMobile ? "100%" : "800px",
          }}
        >
          {/* Title */}
          <Skeleton height={40} width="60%" radius="md" />
          {/* Subtitle */}
          <Skeleton height={20} width="80%" radius="md" />
          {/* Content blocks */}
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              gap: isMobile ? "1rem" : "1.5rem",
              marginTop: isMobile ? "1rem" : "2rem",
            }}
          >
            <Skeleton height={100} radius="md" />
            <Skeleton height={100} radius="md" />
            <Skeleton height={80} radius="md" />
          </Box>
          {/* Button area */}
          <Box
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: "1rem",
              marginTop: isMobile ? "1rem" : "2rem",
            }}
          >
            <Skeleton height={48} width={120} radius="md" />
            <Skeleton height={48} width={120} radius="md" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
